<template>
  <div>
    <hd></hd>
    <el-row :gutter="40">
      <el-col :span="12">
        <el-form ref="validForm" :model="form" label-width="300px">
          <el-form-item label="">
            <h3>{{form.method}}</h3>
          </el-form-item>
          <el-form-item :label="$t('message.ApiName')">
            <el-select v-model="form.method" placeholder="接口名称" @change="methodChange">
              <el-option
                v-for="item in openApis"
                :key="item.method"
                :label="item.name"
                :value="item.method">
                <span style="float: left;">{{item.name}}&nbsp;&nbsp;</span>
                <span style="float: right; color: #8492a6; font-size: 12px">{{item.method}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('message.ApiAddress')"
            prop="url"
            :rules="[
              { required: true, message: '请输入接口地址', trigger: 'blur' }
            ]"
          >
            <el-input v-model="form.url" :placeholder="placeholder.url"></el-input>
          </el-form-item>
          <el-form-item
            label="customerId"
            prop="customerId"
            :rules="[
              { required: true, message: '请输入customerId', trigger: 'blur' }
            ]"
          >
            <el-input v-model="form.customerId" placeholder="由WMS提供"></el-input>
          </el-form-item>
          <el-form-item
            label="appkey"
            prop="appkey"
            :rules="[
              { required: true, message: '请输入appkey', trigger: 'blur' }
            ]"
          >
            <el-input v-model="form.appkey" placeholder="由WMS提供"></el-input>
          </el-form-item>
          <el-form-item
            label="secretkey"
            prop="secretkey"
            :rules="[
              { required: true, message: '请输入secretkey', trigger: 'blur' }
            ]"
          >
            <el-input v-model="form.secretkey" placeholder="由WMS提供"></el-input>
          </el-form-item>
          <div v-for="item in jsonForm">
            <el-form-item
              v-if="v.name"
              v-for="v,k in item"
              :key="k"
              :prop="'jsonForm.' + v.longKey"
              :label="k"
              :rules="[
                { required: v.required, message: '请输入' + v.name, trigger: 'blur' }
              ]"
            >
              <el-input v-model="form.jsonForm[v.longKey]" :placeholder="v.name"></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('validForm')">提交测试</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12" class="main-content">
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item :label="$t('message.SignString')">
            <el-input type="textarea" :rows="5" v-model="genData.signStr" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item :label="$t('message.Md5String')">
            <el-input v-model="genData.sign" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item :label="$t('message.RequestAddress')">
            <el-input type="textarea" :rows="5" v-model="genData.url" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item :label="$t('message.RequestParameter')">
            <el-input type="textarea" :rows="10" v-model="genData.request" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item :label="$t('message.ResponseParameter')">
            <el-input type="textarea" :rows="10" v-model="genData.response" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import md5 from 'md5'
import convert from 'xml-js'
import hd from '../components/Header'
import openApis from '../data/openapi/apis.js'
import axios from 'axios'

import openapiSingleitemSynchronize from '../data/openapi/openapi.singleitem.synchronize.js'
import openapiCombineitemSynchronize from '../data/openapi/openapi.combineitem.synchronize.js'
import openapiEntryorderCreate from '../data/openapi/openapi.entryorder.create.js'
import openapiEntryorderReceive from '../data/openapi/openapi.entryorder.receive.js'
import openapiEntryorderConfirm from '../data/openapi/openapi.entryorder.confirm.js'
import openapiStockoutCreate from '../data/openapi/openapi.stockout.create.js'
import openapiStockoutConfirm from '../data/openapi/openapi.stockout.confirm.js'
import openapiStockoutClose from '../data/openapi/openapi.stockout.close.js'
import openapiStockoutQuery from '../data/openapi/openapi.stockout.query.js'
import openapiInventoryQuery from '../data/openapi/openapi.inventory.query.js'
import openapiInventoryReport from '../data/openapi/openapi.inventory.report.js'
import openapiOrderCancel from '../data/openapi/openapi.order.cancel.js'
import openapiStoreprocessCreate from '../data/openapi/openapi.storeprocess.create.js'
import openapiStoreprocessConfirm from '../data/openapi/openapi.storeprocess.confirm.js'
import openapiAdjustmentorderCreate from '../data/openapi/openapi.adjustmentorder.create.js'
import openapiAdjustmentorderConfirm from '../data/openapi/openapi.adjustmentorder.confirm.js'
import menus from '../data/apis.js'

export default {
  components: {
    hd
  },
  name: 'HelloWorld',
  created () {
    this.contentEditable = false
    this.form.method = this.$route.query.method
    this.setData(this.form.method)
    this.setTitle()
  },
  data () {
    return {
      content: '## 请求参数\n',
      openapiMethodData: {
        xmlResponse: '',
        xmlRequest: ''
      },
      openapiData: {
        'openapi.singleitem.synchronize': openapiSingleitemSynchronize,
        'openapi.combineitem.synchronize': openapiCombineitemSynchronize,
        'openapi.entryorder.create': openapiEntryorderCreate,
        'openapi.entryorder.receive': openapiEntryorderReceive,
        'openapi.entryorder.confirm': openapiEntryorderConfirm,
        'openapi.stockout.create': openapiStockoutCreate,
        'openapi.stockout.confirm': openapiStockoutConfirm,
        'openapi.stockout.close': openapiStockoutClose,
        'openapi.stockout.query': openapiStockoutQuery,
        'openapi.inventory.query': openapiInventoryQuery,
        'openapi.inventory.report': openapiInventoryReport,
        'openapi.order.cancel': openapiOrderCancel,
        'openapi.storeprocess.create': openapiStoreprocessCreate,
        'openapi.storeprocess.confirm': openapiStoreprocessConfirm,
        'openapi.adjustmentorder.create': openapiAdjustmentorderCreate,
        'openapi.adjustmentorder.confirm': openapiAdjustmentorderConfirm
      },
      placeholder: {
        url: '由WMS提供'
      },
      form: {
        method: '',
        url: '',
        customerId: '',
        appkey: '',
        secretkey: '',
        jsonForm: {
        }
      },
      genData: {
        url: '',
        request: '',
        response: ''
      },
      openApis: openApis,
      jsonForm: []
    }
  },
  methods: {
    setData (method) {
      // this.$refs['validForm'].resetFields()
      if (this.openapiData[method]) {
        this.openapiMethodData.xmlRequest = this.openapiData[method].xmlRequest
        this.openapiMethodData.xmlResponse = this.openapiData[method].xmlResponse
      } else {
        this.openapiMethodData.xmlRequest = ''
        this.openapiMethodData.xmlResponse = ''
      }
      let jsonData = convert.xml2js(this.openapiMethodData.xmlRequest, {compact: true, spaces: 4})
      this.jsonForm = this.genJsonFormData(jsonData.request)

      if (method.indexOf('confirm') > -1) {
        this.placeholder.url = '由ERP提供'
      } else {
        this.placeholder.url = '由WMS提供'
      }
    },
    methodChange () {
      setTimeout(() => {
        this.setData(this.form.method)
      })
      this.genData.url = ''
      this.genData.request = ''
      this.genData.response = ''
      this.genData.sign = ''
      this.genData.signStr = ''
    },
    genJsonFormData (jsonData, parentKey = '') {
      let jsonForm = []
      for (let k in jsonData) {
        let item = jsonData[k]
        let newKey = parentKey ? `${parentKey}.${k}` : k
        if (!item._text) {
          console.log('itemitemitemitemitem', item)
          jsonForm = jsonForm.concat(this.genJsonFormData(item, newKey))
        } else {
          let required = item._text.indexOf('必填') > -1
          let conditionRequired = false
          if (/[\u4e00-\u9fa5]必填/.test(item._text)) {
            conditionRequired = true
          }
          if (required) {
            jsonForm.push({
              [newKey]: {
                name: item._text,
                key: k,
                longKey: newKey.replace(/\./g, '*'),
                required: required && !conditionRequired
              }
            })
          }
        }
      }
      return jsonForm
    },
    setTitle () {

    },
    onSubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let args = this.genArgs()
          this.genData.request = this.genRequestXml()
          this.genData.sign = this.genSign(args, this.genData.request)
          this.genData.url = this.genUrl([...args, `sign=${this.genData.sign}`])
          this.post(this.genData.url, this.genData.request)
        } else {
          console.log('validvalid111', valid)
        }
      })
    },
    genSign (args, xml) {
      let str = this.form.secretkey
      str += args.join('').replace(/=/g, '')
      str += xml
      str += this.form.secretkey
      this.genData.signStr = str
      str = md5(str)
      return str.toUpperCase()
    },
    genArgs () {
      let args = [
        `app_key=${this.form.appkey}`,
        `customerId=${this.form.customerId}`,
        `format=xml`,
        `method=${this.form.method}`,
        `sign_method=md5`,
        `timestamp=${this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`,
        `v=2.0`
      ]
      return args
    },
    genUrl (args) {
      let url = this.form.url
      url += `?${args.join('&')}`
      return url
    },
    genRequestXml () {
      let json = {request: {}}
      for (let k in this.form.jsonForm) {
        let items = k.split('*')
        let lastItem = items[items.length - 1]
        let currentItem = json.request
        for (let item of items) {
          if (lastItem === item) {
            currentItem[item] = this.form.jsonForm[k]
          } else {
            currentItem[item] = currentItem[item] || {}
            currentItem = currentItem[item]
          }
        }
      }
      let xml = '<?xml version="1.0" encoding="utf-8"?>\n'
      xml += convert.js2xml(json, {compact: true, ignoreComment: true, spaces: 4})
      return xml
    },
    post (path, data) {
      axios.post(
        path,
        data,
        {
          headers: {'Content-Type': 'text/xml'},
          responseType: 'xml'
        }
      ).then(res => {
        this.genData.response = res.data
        this.$message.success('成功')
      }).catch(error => {
        try {
          if (typeof error.response.data !== 'string') {
            this.genData.response = JSON.stringify(error.response.data)
          } else {
            this.genData.response = error.response.data
          }
        } catch (e) {
          this.genData.response = error.response.data
        }
        this.$message.error('失败')
      })
    }
  },
  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.method = newVal.method
        setTimeout(() => {
          this.setData(this.method)
        })
        this.setTitle()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/OpenApiDebug.vue